import {
  // Alert,
  Button,
  Checkbox,
  CheckboxGroup,
  Dialog,
  Form,
  Input,
  Loading,
  // Tooltip,
  InputNumber,
  Message,
  MessageBox,
  Dropdown,
  // Tag,
  PinCode,
  Radio,
  RadioGroup,
  Table,
  Col,
  Row,
  Breadcrumb,
  Tabs,
  Player,
  Carousel,
  Switch,
  /* eslint-disable no-unused-vars */
  Style,
} from '@zoom/zoom-ui';
import Vue from 'vue';
import Select from '@zoom/zoom-ui/src/components/select';
import Popover from '@zoom/zoom-ui/src/components/popover';
import Drawer from '@zoom/zoom-ui/src/components/drawer';
import Collapse from '@zoom/zoom-ui/src/components/collapse';
import Autocomplete from '@zoom/zoom-ui/src/components/autocomplete'
import Skeleton from '@zoom/zoom-ui/src/components/skeleton';
// import SetPassword from '@zoom/zoom-ui/src/components/set-password';
import CountrySelect from '@zoom/zoom-ui/src/components/country-select';
import PopupCaptcha from '@zoom/zoom-ui/src/components/popup-captcha';
import CheckboxList from '@zoom/zoom-ui/src/components/checkbox-list';
import Tooltip from '@/components/zoom-ui-plus/tooltip/tooltip.vue';
import Tag from '@/components/zoom-ui-plus/tag/tag.vue'; // https://zoomvideo.atlassian.net/browse/ZOOM-749150
import TagGroup from '@zoom/zoom-ui/src/components/tag-group/tag-group.vue';
import Alert from '@/components/zoom-ui-plus/monitor-alert/index.vue';

// Vue.use(Alert);
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(Popover);
// Vue.use(Tooltip);
Vue.use(Loading);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(Message);
Vue.use(MessageBox);
Vue.use(Dropdown);
Vue.use(Drawer);
// Vue.use(Tag);
Vue.use(PinCode);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Collapse);
Vue.use(Autocomplete)
Vue.use(Skeleton);
// Vue.use(SetPassword);
Vue.use(CountrySelect);
Vue.use(Row);
Vue.use(Col);
Vue.use(Table);
Vue.use(Breadcrumb);
Vue.use(PopupCaptcha);
Vue.use(Tabs);
Vue.use(CheckboxList);
Vue.use(Player);
Vue.use(Carousel);
Vue.component('ZmTooltip', Tooltip);
Vue.component('ZmTag', Tag);
Vue.component('ZmTagGroup', TagGroup);
Vue.component('ZmAlert', Alert);
Vue.use(Switch);
